import { Link } from "react-router-dom";
import { Chevron } from "../../Icons";
import style from "./index.module.css";
import { useTranslation } from "../../../hooks/useTranslation";

const ViewMore = ({ link }: { link: string }) => {
  const { locale } = useTranslation();
  return (
    <Link to={link} className={style.read_more}>
      <div className={style.icon}>
        <Chevron width="17" height="17" color="#fff" />
      </div>
      <span>{locale("view_more")}</span>
    </Link>
  );
};

export default ViewMore;
